

export default {
    getUser(params) {
        let path = process.env.apiPath + '/user/user.get';
        params = params || {};
        params.queryMethod = 'GET';
        params.fields = 'user.roles,user.advertiser,user.publisher,user.timezone,user.locale,user.responsible_manager,advertiser.advertiser_key,publisher.name,publisher.surname,publisher.account,publisher.payment_details,publisher.rank,publisher.subscribed,publisher.contact,publisher.contacts';
        params.removeLocale = true;
        return this.makeRequest(path, params);
    },

    getCurrencies() {
        let path = process.env.apiPath + '/user/currencyRatios.getCurrencies';
        return this.makeRequest(path, { queryMethod: 'GET' });
    },

    getCurrentCurrencyRatios(params) {
        let path = process.env.apiPath + '/user/currencyRatios.getCurrent';
        params = params || 'currency_ratio.rates';
        return this.makeRequest(path, params);
    },

    searchRegions(params) {
        let path = process.env.apiPath + '/user/regions.search';
        params = params || {};
        params.fields = 'region.type,region.parent';
        return this.makeRequest(path, params);
    },

    searchCurrencyRatios(params) {
        let path = process.env.apiPath + '/user/currencyRatios.search';
        params = params || {};
        params.fields = 'currency_ratio.rates';
        return this.makeRequest(path, params);
    },

    userEdit(params) {
        let path = process.env.apiPath + '/user/user.edit';
        params = params || {};
        return this.makeRequest(path, params);
    },

    changePassword(params) {
        let path = process.env.apiPath + '/user/user.changePassword';
        params = params || {};
        return this.makeRequest(path, params);
    },

    getServerStorage(params) {
        let path = process.env.apiPath + '/user/clientStorage.get';
        params = params || {};
        return this.makeRequest(path, params);
    },

    setServerStorage(params) {
        let path = process.env.apiPath + '/user/clientStorage.set';
        params = params || {};
        return this.makeRequest(path, params);
    }
};